<template>
  <div>
    <TableBlock ref="tableData" @checkVal="selectVal" :columns="columns" :topWidth="30" :action="action" :param="formData" :navHeight="487" :topHegiht="350">
      <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
          <div class="common-items-center"> 
              <el-input style="margin-right: 10px;width: 300px;" placeholder="产品名称/位置区域" v-model="formData.keywords"></el-input>
              <el-input style="margin-right: 10px;width: 300px;" placeholder="序列号" v-model="formData.serialNo"></el-input>
              <el-button type="primary"  @click="serachBtn">查询</el-button>
              <el-button   @click="resetBtn">重置</el-button>
            </div>
          <div>
               <el-button type="primary" class="add-btn" @click="operateShow(2)" style="padding:10px">导出</el-button>
          </div>
      </div>
    </TableBlock>
    <!-- <div class="common-items-center common-space-between" style="margin-bottom: 16px;">
      <div class="common-items-center">
        <InputBlock ref="keyWord" keyVal="keywords" right="20" paddButtom="0" @getVal="getVal" width="300"
          placeholder="请输入产品名称、位置区域" />
          <InputBlock ref="serialNo" keyVal="serialNo" right="20" paddButtom="0" @getVal="getSerialNoVal" width="300"
          placeholder="请输入序列号" />
        <el-button type="primary" @click="serachBtn">查询</el-button>
        <el-button @click="resetBtn">重置</el-button>
      </div>
      <div>
        <el-button type="primary" @click="addBtn">设备报警设置</el-button>
      </div>
    </div>
    <div class="warp-table">
      <el-table size="small" ref="giftTable" :data="tableData" :height="THeight" row-key="id" lazy
        @selection-change="checkSelectBtn">
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" type="selection"
          width="60"></el-table-column>
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" prop="name" label="图片"
          width="120">
          <template slot-scope="scope">
            <div>
              <img style="height: 30px;width: 30px" :src="scope.row.resourcesUrl">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="serialNo" label="序列号"
          width="200"></el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="productName"
          label="设备名称" width="160"></el-table-column>
        <el-table-column align="center" header-align="center" :show-overflow-tooltip="true" prop="address" label="位置区域"
          > </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="deviceConfig"
          label="接收方式">
          <template slot-scope="scope">
            <div>
              {{ receiveMode(scope.row, 1) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="createTime" label="接收人员"
          width="300">
          <template slot-scope="scope">
            <div>
              {{ receiveMode(scope.row, 2) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="updateTime" label="更新时间"
         ></el-table-column>
      </el-table>
      <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size" />
    </div> -->

    <!-- <myDiglog :show="isShow">
            <plice ref="plice" v-if="isOne" :data="selectionArr" :tableSelect="selectionArr" :policeList="policeList"></plice>
        </myDiglog> -->
    <!-- <el-dialog :show-close="true" @close="close()" title="设备报警设置" :visible.sync="isShow" width="36%"
      :close-on-click-modal="false">
      <plice ref="plice" v-if="isOne" :data="selectionArr" :tableSelect="selectionArr" :policeList="policeList"></plice>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="sumbit">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { operate } from '@/utils/config'
import { postFun } from '@/utils/httpFun'
import {columns} from './columns'
import {downFile} from '@/utils/util'
import plice from './block_police_disepose.vue'
import axios from 'axios'

export default {
  name: 'index',
  components: {
    plice
  },
  props: {
    edits: {
      type: Object,
      default: () => { }
    }
  },
  data: () => ({
    action:operate.GETPOLICELIST,
    columns:'',
    isShow: false,
    queueID: 0,
    tableData: [],
    formData: {
      projectId: '',
      keywords: null,
      serialNo:'',
      hasBingding:1
    },
    current: 1,
    size: 10,
    total: 0,
    selectionArr: [],
    policeList: [],
    isOne: false,
    policeList:[]
  }),
  created() {
    this.columns = columns(this);
    this.formData.projectId = this.edits.id;
  },
  methods: {
    selectVal(e){
      this.policeList = e;
    },
    receiveMode(obj, index) {
      if (obj.deviceConfig == null || obj.deviceConfig == undefined || obj.deviceConfig.length == 0) return;
      if (index == 1) {
        let arr = [];

        obj.deviceConfig.shortMessageState ? arr.push('短信') : '';
        obj.deviceConfig.voiceState ? arr.push('电话') : '';
        obj.deviceConfig.oaState ? arr.push('公众号') : '';

        let txt = arr.join(',')
        return txt;

      } else if (index == 2) {
        if (obj.deviceConfig.pushUserList == null || obj.deviceConfig.pushUserList == undefined || obj.deviceConfig.pushUserList.length == 0) return;
        let arr = [];
        obj.deviceConfig.pushUserList.forEach((item, index) => {
          arr.push(item.userName);
        })

        let txt = arr.join(',');
        return txt;
      }
    },
    getSerialNoVal(e){
      this.formData.serialNo = e.val;
    },
    getVal(e) {
      this.formData.keywords = e.val;
    },
    close() {
      this.isOne = false;
      this.isShow = false;
    },
    sumbit() {
      this.$refs.plice.add();
      this.close();
      setTimeout(() => {
        this.getDatas()
      }, 500)
    },
    addBtn() {

      if (this.selectionArr.length == 0) {
        this.$message.warning("没有选择设备");
        return;
      }

      postFun(url.PROJECT.GETPERSONNER, { state: 3 }, res => {
        this.isOne = true;
        this.policeList = res.data;
        this.isShow = true; 
        // this.$bus.$emit('setBtn',[
        //   {
        //     text:'确认',
        //     type:'primary',
        //     callbalck:res=>{
        //       this.$refs.plice.add();
        //       this.isShow = false;
        //       this.isOne = false;
        //       // -----------------------------测试两次
        //       setTimeout(()=>{
        //         this.getDatas()
        //       },500)
        //       // this.getDatas()
        //     }
        //   },
        //   {
        //     text:'取消',
        //     callbalck:res=>{
        //       this.isShow = false;
        //     }
        //   }
        // ])
        // this.$bus.$emit('setWidth','36%')
        // this.$bus.$emit('setTitle','设备报警设置')
      })
    },
    fileExport(){

      console.log('this.',this.policeList)
      let deviceIds = []

      this.policeList.forEach(item=>{
        deviceIds.push(item.deviceId)
      })

      let param = {
        ...this.formData,
        deviceIds:deviceIds
      }

      axios({
        method:'post',
        headers: { 'Authorization':localStorage.getItem('YunWeiTikenBRJ') },
        responseType: 'arraybuffer',
        url:operate.EXPORTPOLICE,
        data:param
      }).then(res=>{
        console.log('导出成员管理',res)
        if(!!res && res.status == 200){
          downFile(res.data,'设备报警管理','xlsx')
        }else if(!!res){
          this.$message.warning(res.message)
        }
      }).catch(err=>{
        console.log('报错',err);
        this.$message.warning(err.message);
      })
    },
    // 操作
    operateShow(index, row) {
      this.index = index;
      if(index == 2){
        this.fileExport();
      }
    },
    //获取所有的数据
    async getDatas() {
      let parms = {
        param: {
          ...this.formData
        },
        current: this.current,
        size: this.size
      }
      await postFun(url.PROJECT.GETPOLICEPAGE, parms, res => {
        if (!res.data) {
          this.tableData = []
        } else {
          this.tableData = res.data.records
          this.total = res.data.total
          this.size = res.data.size
          this.current = res.data.current
        }
      })
    },
    //查询
    serachBtn() {
      this.tableData = []
      this.$nextTick(res=>{
           this.$refs.tableData.getDatas() 
       })
    },

    //重置
    resetBtn() {
      this.tableData = []
      this.formData.keywords = null
      this.formData.serialNo = null
      this.$nextTick(res=>{
          this.$refs.tableData.resetHttp() 
      })
    },
    //多选
    checkSelectBtn(ev) {
      // console.log('多选',ev)
      this.selectionArr = ev;
    },
    //分页
    getPage(ev) {
      this.size = ev.pageSize
      this.current = ev.pageNo
      this.getDatas()
    },
  }
}
</script>

<style lang="scss" scoped>
.warp-btn {
  display: flex;
  justify-content: flex-start;
}

.right-div {
  height: 300px;
  //  border: 1px solid rgba(240,240,240,0.6);
  //  box-shadow: 0px 0px 2px 0 rgba(205,216,233,0.29);
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;

  .warp-table {
    padding-top: 10px;
  }
}

::v-deep .el-dialog__header {
  // width: 92%;
  height: 23px;
  background: #F8F9FA;
  box-shadow: 0px 1px 0px 0px rgb(237 238 240);
  border-radius: 12px 12px 0 0;
}

::v-deep .el-dialog {
  border-radius: 12px;
}</style>